import React from 'react';
import { ButtonContainedGrey } from 'src/shared/components/form/buttonContainedGrey';
import Menu from '@mui/material/Menu';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import GetAppIcon from '@mui/icons-material/GetApp';

interface IMenuItem {
  Icon: JSX.Element;
  label: string;
}

export default function MemberExportButton() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const menuItems: IMenuItem[] = [
    {
      Icon: <SendIcon />,
      label: 'Sent mail',
    },
    {
      Icon: <DraftsIcon />,
      label: 'Drafts',
    },
    {
      Icon: <InboxIcon />,
      label: 'Inbox',
    },
  ];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonContainedGrey
        aria-controls='customized-menu'
        aria-haspopup='true'
        onClick={handleClick}
        startIcon={<GetAppIcon />}
        endIcon={<ArrowDropDownIcon />}
      >
        Exportera
      </ButtonContainedGrey>
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map((item) => {
          return (
            <MenuItem
              key={item.label}
              sx={{
                '&:focus': {
                  backgroundColor: 'primary.main',
                  '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: 'white',
                  },
                },
              }}
            >
              <ListItemIcon>{item.Icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
